import React, { useState, useEffect } from "react";

import SystemDiagnostic from "../../_components/system-diagnostic/system-diagnostic.component";
import CameraDiagnostic from "../../_components/camera-diagnostic/camera-diagnostic.component";
import KeyboardDiagnostic from "../../_components/keyboard-diagnostic/keyboard-diagnostic.component";

import "./diagnostic-test.styles.css";

const DIAGNOSTIC_TESTS = [
  {
    name: "system",
  },
  {
    name: "camera",
  },
  {
    name: "keyboard",
  },
];

const DiagnosticTest = () => {
  const [diagnosticTests, setDiagnosticTests] = useState([]);
  const [showSuccessMessage, setShowSuccessMessage] = useState(false);
  useEffect(() => {
    const finalTests = DIAGNOSTIC_TESTS.map((test, i) => {
      test["status"] = i === 0 ? "running" : "pending";
      test["result"] = null;
      return test;
    });
    setDiagnosticTests(finalTests);
  }, []);

  const changeDiagnosticResults = (index, result, status) => {
    const newDiagnostictests = [...diagnosticTests];
    newDiagnostictests[index]["result"] = result;
    newDiagnostictests[index]["status"] = status;
    if (newDiagnostictests[index + 1] && status !== "error") {
      newDiagnostictests[index + 1]["status"] = "running";
    }
    setDiagnosticTests(newDiagnostictests);
  };

  useEffect(() => {
    if (diagnosticTests.length < 1) return;
    for (let i = 0; i < diagnosticTests.length; i++) {
      console.log(diagnosticTests[i]);
      if (diagnosticTests[i]?.status !== "successful") return;
    }
    console.log("hereee");
    setShowSuccessMessage(true);
  }, [diagnosticTests]);

  return (
    <div className="diagnosis-test-wrapper">
      <div className="diagnosis-test-container">
        <div className="diagnosis-wrappers">
          {showSuccessMessage ? (
            <>
              <span className="diagnosis-text-1">Congratulations!</span>
              <span className="diagnosis-text-2">
                You are all set for the test
              </span>
            </>
          ) : (
            <>
              <span className="diagnosis-text-1">Please wait</span>
              <span className="diagnosis-text-2">While we run some </span>
              <span className="diagnosis-text-3">
                diagnostics on your system...
              </span>
            </>
          )}
        </div>
        <div className="diagnosis-wrappers">
          {diagnosticTests.map(
            ({ name, status }, i) =>
              (name === "system" && (
                <SystemDiagnostic
                  key={i}
                  status={status}
                  index={i}
                  changeDiagnosticResults={changeDiagnosticResults}
                />
              )) ||
              (name === "camera" && (
                <CameraDiagnostic
                  key={i}
                  status={status}
                  index={i}
                  changeDiagnosticResults={changeDiagnosticResults}
                />
              )) ||
              (name === "keyboard" && (
                <div key={i}>
                  <KeyboardDiagnostic
                    status={status}
                    index={i}
                    changeDiagnosticResults={changeDiagnosticResults}
                  />
                </div>
              ))
          )}
        </div>
        {/* {showSuccessMessage && (
          <div className="success-message">
            Congratulations! Looks like you are all set for the test!
          </div>
        )} */}
      </div>
      <div className="diagnostic-note-wrapper">
        <div className="diagnostic-note-container">
          <span className="diagnostic-note">Please note: </span>
          <ol>
            <li>
              Automated system check do not guarantee your equipment's
              functionality on exam day.
            </li>
            <li>
              <span className="camera-diagnostics-question">
                Where do you place a webcam?
              </span>
              <span>
                The best place to position your webcam is just above your eye
                level. You can angle it slightly downward so that your camera
                can capture a good portion of your upper body and face.
              </span>
            </li>
          </ol>
        </div>
      </div>
    </div>
  );
};

export default DiagnosticTest;
